import React from 'react';
import { Affix } from 'antd';
import cn from 'classnames';
import AddInfoBtn from '../AddInfoBtn/AddInfoBtn';
import Search from '../Search/Search';
import OpenResetFilter from '../OpenResetFilter/OpenResetFilter';
import styles from './Actions.module.scss';

const Actions = () => {
  return (
    <Affix className={cn('dispex-filter-button', styles.root)} offsetTop={10}>
      <div className={styles.container}>
        <AddInfoBtn />
        <Search />
        <OpenResetFilter />
      </div>
    </Affix>
  );
};

export default Actions;
